/* eslint-disable react-hooks/exhaustive-deps */
import { Button, message, Row } from 'antd';
import { useEffect, useState } from 'react';
import { formatDate } from '../../../helpers/genericHelper';
import API from '../../../services/API';
import CustomText from '../../CustomText';
import LoaderComponent from '../../Loader';
import UploadSillaDocument from './UploadSillaDocument';

function SillaDocuments({ userId }) {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddDocumentModal, setShowAddDocumentModal] = useState(false);

  useEffect(() => {
    loadData(true);
  }, []);

  const loadData = async (reload) => {
    try {
      if (reload) {
        setLoading(true);
      }
      let res = await API.getDocuments(userId);
      setDocuments(res.uploadedDocuments);
    } catch (e) {
      message.error(e.message);
    } finally {
      setLoading(false);
    }
  }

  const openAddDocumentModal = () => setShowAddDocumentModal(true);
  const closeDocumentModal = (reload) => {
    loadData(reload);
    setShowAddDocumentModal(false);
  }

  return (
    <div className="ant-list-box table-responsive" style={{ maxHeight: 400, background: 'white' }}>
      <Row style={{ display: 'flex', justifyContent: 'flex-end', padding: 12 }}>
        <Button onClick={openAddDocumentModal}>
          Upload Document
        </Button>
      </Row>


      {loading && <LoaderComponent tip={'loading document'} />}
      <table className="width-100">
        <thead>
          <tr>
            <th>Id</th>
            <th>File Name</th>
            <th>Type</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          { }
          {(documents && documents.length > 0) ? documents.map((value) => {
            return (
              <tr key={value.value}>
                <td>
                  <CustomText
                    dataSet={value}
                    property1={'documentId'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={value}
                    property1={'filename'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={value}
                    property1={'type'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={value}
                    property1={'created'}
                    formatter={formatDate}
                  />
                </td>

              </tr>
            );
          }) :
            <tr>
              <td colSpan="4">
                <Row className="no-data-card" >No document(s) found</Row>
              </td>
            </tr>}
        </tbody>
      </table>
      <UploadSillaDocument
        showAddDocumentModal={showAddDocumentModal}
        closeDocumentModal={closeDocumentModal}
        userId={userId} />
    </div>
  );
}

export default SillaDocuments;
